import { render, staticRenderFns } from "./CmgAchievedBadgeModal.vue?vue&type=template&id=80a1da56&scoped=true&lang=pug"
import script from "./cmg-achieved-badge-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-achieved-badge-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgAchievedBadgeModal.vue?vue&type=style&index=0&id=80a1da56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80a1da56",
  null
  
)

export default component.exports